import React from "react"
import PropTypes from "prop-types"
import PinPurple from "../mapAssets/pin-purple.png"
import PinOrange from "../mapAssets/pin-orange.png"
import PinTeal from "../mapAssets/pin-teal.png"
import PinYellow from "../mapAssets/pin-yellow.png"

import {
  StyledContainer,
  StyledContentContainer,
  StyledName,
  StyledTime,
  StyledTraffic,
  StyledFirstLine,
  StyledIcon,
} from "./KeyRoadInfoLabel.styles"

const pins = {
  orange: PinOrange,
  teal: PinTeal,
  yellow: PinYellow,
  purple: PinPurple,
}

const KeyRoadInfoLabel = ({ aproxTime, name, trafficThroughput, colors }) => {
  return (
    <StyledContainer>
      <StyledIcon src={pins[colors.name]} />

      <StyledContentContainer>
        <StyledFirstLine>
          <StyledName>{name}</StyledName>
          {aproxTime && <StyledTime>({aproxTime})</StyledTime>}
        </StyledFirstLine>

        <StyledTraffic>{trafficThroughput}</StyledTraffic>
      </StyledContentContainer>
    </StyledContainer>
  )
}

KeyRoadInfoLabel.propTypes = {
  aproxTime: PropTypes.string,
  name: PropTypes.string,
  trafficThroughput: PropTypes.string,
  colors: PropTypes.shape({
    name: PropTypes.string,
    body: PropTypes.string,
    border: PropTypes.string,
  }).isRequired,
}
KeyRoadInfoLabel.defaultProps = {
  aproxTime: null,
  name: null,
  trafficThroughput: null,
}
export default KeyRoadInfoLabel
